import React from 'react';
import Button from '../../ui/Button';
import { PrinterIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';

const ReturnLabelSuccess = ({ labelData, existingLabelData, allHaveLabels }) => {
  // Determine which data to use
  const data = existingLabelData || labelData;
  const isExistingLabel = allHaveLabels && existingLabelData;
  
  if (!data) return null;

  const containerClasses = isExistingLabel 
    ? "bg-white p-6 rounded-lg shadow-sm border border-gray-200"
    : "p-4 text-center";

  const contentClasses = isExistingLabel 
    ? "p-4 text-center"
    : "";

  return (
    <div className={containerClasses}>
      <div className={contentClasses}>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
          <svg className="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-800">Return Label Generated Successfully!</h3>
        
        {/* Tracking info - handle both data formats */}
        {(data.trackingNumber || data.tracking_number) && (
          <p className="mt-1 text-sm text-gray-600">
            Tracking Number: <span className="font-medium text-gray-700">{data.trackingNumber || data.tracking_number}</span>
          </p>
        )}
        {data.carrier && (
          <p className="text-sm text-gray-600">
            Carrier: <span className="font-medium text-gray-700">{data.carrier}</span>
          </p>
        )}
        
        {/* Download button - handle both URL formats */}
        {(data.labelUrl || data.label_url) && (
          <div className="mt-6 mb-4">
            <Button 
              onClick={() => window.open(data.labelUrl || data.label_url, '_blank')}
              variant="primary"
              className="w-full md:w-auto text-base px-8 py-3"
              icon={<ArrowDownTrayIcon className="h-5 w-5" />}
            >
              View / Download Return Label
            </Button>
          </div>
        )}

        {/* Next steps instructions */}
        <div className="mt-6 text-left text-sm text-gray-700 bg-gray-50 p-4 rounded-md">
          <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
            <PrinterIcon className="h-5 w-5 mr-2 text-gray-500" />
            Next Steps:
          </h4>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Print the return shipping label. Ensure it is clear and scannable.</li>
            <li>Securely attach the label to your package. Avoid placing tape over barcodes if possible.</li>
            <li>Drop off the package at the nearest <span className="font-medium">{data.carrier || 'carrier'}</span> location.</li>
            <li>Alternatively, some carriers (like UPS, FedEx, etc.) may offer in-store QR code scanning or label printing services if you don't have a printer. Please check with <span className="font-medium">{data.carrier || 'your carrier'}</span> for available options.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ReturnLabelSuccess; 